import { render, staticRenderFns } from "./Posts.vue?vue&type=template&id=2209115c&scoped=true&"
import script from "./Posts.vue?vue&type=script&lang=js&"
export * from "./Posts.vue?vue&type=script&lang=js&"
import style0 from "./Posts.vue?vue&type=style&index=0&id=2209115c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2209115c",
  null
  
)

export default component.exports